namespace Nobox.Nobox {
    export interface AccountForm {
        TenantId: Serenity.IntegerEditor;
        Name: Serenity.StringEditor;
        Category: AccountCategoryEditor;
        Channel: Serenity.ServiceLookupEditor;
        Users: Serenity.ServiceLookupEditor;
        Status: Serenity.BooleanEditor;
        Info: Serenity.StringEditor;
        ApiId: Serenity.StringEditor;
        ApiClient: Serenity.StringEditor;
        ApiSecret: Serenity.StringEditor;
        ApiExtra: Serenity.StringEditor;
        IsSMTP: IsSMTPEditor;
        Host: Serenity.StringEditor;
        Port: SMTPPortEditor;
        UseSSL: Serenity.BooleanEditor;
        From: Serenity.StringEditor;
        Username: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
        Provider: ProviderEmailEditor;
        BaseUrlApi: Serenity.StringEditor;
        EndpointApi: Serenity.StringEditor;
        FromApi: Serenity.StringEditor;
        KeyApi: Serenity.StringEditor;
        BotActive: Serenity.BooleanEditor;
        BotName: Serenity.StringEditor;
        BotEngine: BotEngineEditor;
        BotEndpoint: Serenity.StringEditor;
        BotChannel: Serenity.StringEditor;
        BotUsername: Serenity.StringEditor;
        BotPassword: Serenity.PasswordEditor;
        BotOptions: Serenity.StringEditor;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
    }

    export class AccountForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Account';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountForm.init)  {
                AccountForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = AccountCategoryEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.BooleanEditor;
                var w5 = IsSMTPEditor;
                var w6 = SMTPPortEditor;
                var w7 = s.PasswordEditor;
                var w8 = ProviderEmailEditor;
                var w9 = BotEngineEditor;
                var w10 = CustomDateTimeEditor;

                Q.initFormType(AccountForm, [
                    'TenantId', w0,
                    'Name', w1,
                    'Category', w2,
                    'Channel', w3,
                    'Users', w3,
                    'Status', w4,
                    'Info', w1,
                    'ApiId', w1,
                    'ApiClient', w1,
                    'ApiSecret', w1,
                    'ApiExtra', w1,
                    'IsSMTP', w5,
                    'Host', w1,
                    'Port', w6,
                    'UseSSL', w4,
                    'From', w1,
                    'Username', w1,
                    'Password', w7,
                    'Provider', w8,
                    'BaseUrlApi', w1,
                    'EndpointApi', w1,
                    'FromApi', w1,
                    'KeyApi', w1,
                    'BotActive', w4,
                    'BotName', w1,
                    'BotEngine', w9,
                    'BotEndpoint', w1,
                    'BotChannel', w1,
                    'BotUsername', w1,
                    'BotPassword', w7,
                    'BotOptions', w1,
                    'In', w10,
                    'Up', w10
                ]);
            }
        }
    }
}
